import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { number } from '../../../value/types/numbers/index.mjs';
var int = _objectSpread(_objectSpread({}, number), {}, {
  transform: Math.round
});
export { int };